import axios from "axios";
import { AppTheme } from "../models";
import { isNotEmpty } from "@/fp";

const user_settings = () => {
  let user_email: string;

  const init = (email: string) => {
    user_email = email;
  };

  const gen_key = (key: string) => {
    return user_email.substring(0, user_email.indexOf("@")) + "_" + key;
  };

  const key = <T>(key: string, defaultVal: () => T) => {
    const get = async (): Promise<T> => {
      try {
        const res = await axios.get("/extproxy/integrations/ui-settings");
        const v: T = res.data.value.uiSettings[gen_key(key)];
        const val: T = isNotEmpty(v) ? v : defaultVal();
        return val;
      } catch (e) {
        console.log(`error in getting settings for key : ${key}`, e);
        return defaultVal();
      }
    };

    const update = async (val: T) => {
      try {
        await axios.put("/extproxy/integrations/ui-settings", {
          uiSettings: {
            [gen_key(key)]: val,
          },
        });
        return val;
      } catch (e) {
        console.log(`error in getting settings for key : ${key}`, e);
        return defaultVal;
      }
    };

    return {
      get,
      update,
    };
  };

  return {
    init,
    key,
  };
};

export const org_settings = <T>(key: string, defaultVal: T) => {
  const get = async (): Promise<T> => {
    try {
      const res = await axios.get("/extproxy/integrations/ui-settings");
      const val: T = res.data.value.uiSettings[key] || defaultVal;
      return val;
    } catch (e) {
      console.log(`error in getting settings for key : ${key}`, e);
      return defaultVal;
    }
  };

  const update = async (val: T) => {
    try {
      await axios.put("/extproxy/integrations/ui-settings", {
        uiSettings: {
          [key]: val,
        },
      });
      return val;
    } catch (e) {
      console.log(`error in getting settings for key : ${key}`, e);
      return defaultVal;
    }
  };

  return {
    get,
    update,
  };
};

export const UserSettings = user_settings();

export const user_theme = UserSettings.key<AppTheme>("theme", () => "light");
